import { months } from "../elements/Months";

export const renderFormattedDate = (theDate, dateFormat) => {
	let j = theDate.getDate();
	let m = theDate.getMonth() + 1; // because January is 0 in the array

	let formattedDate = "";

	switch (dateFormat) {
		case "month_day":
			var monthnames = months('mmm');
			formattedDate = monthnames[m] + " " + j;
			break;
		case "month_day_dash":
			formattedDate = m + "/" + j;
			break;
		case "month_day_dot":
			formattedDate = m + "." + j;
			break;
		default: // case "day"
			formattedDate = j;
			break;
	}

	return formattedDate;
}

export const renderFormattedMonth = (theDate) => {
	let formatMonthName = limelight.data.monthname_date_format;
	const monthNumber = parseInt(theDate.split('-')[1]); // -1 to coincide with month array

	let formatDate = "";

	switch (formatMonthName) {
		case "month_full":
			formatDate = `${months()[monthNumber - 1]}`
			break;
		case "month_full_year":
			formatDate = `${months()[monthNumber - 1]} ${theDate.split('-')[0]}`
			break;
		case "mon_year":
			formatDate = `${months('mmm')[monthNumber - 1]} ${theDate.split('-')[0]}`
			break;
		default: // case "mon"
			formatDate = `${months('mmm')[monthNumber - 1]}`;
			break;
	}

	return formatDate;
}
